import { z } from 'zod';

import { BookTypeEnum } from '../../enums';
import { levelEnumValidator } from '../../validators';

export const UpdateBookSchema = z.object({
  author: z.string().optional().nullable(),
  content: z.string().optional(),
  language: z.string().min(2).max(10).optional(),
  levels: z.array(levelEnumValidator).min(1).optional(),
  title: z.string().min(1).optional(),
  type: z.nativeEnum(BookTypeEnum).optional(),
});

export type IUpdateBookDto = z.infer<typeof UpdateBookSchema>;
